import { DEFAULT_BANNERS } from '../constants/banner';

import { hashCode } from './string';

export const getDefaultBannerSource = (
  id: string | undefined,
): string | undefined => {
  return id
    ? DEFAULT_BANNERS[hashCode(id) % DEFAULT_BANNERS.length]
    : undefined;
};
